import { jsx, jsxs } from "react/jsx-runtime";
import { useClassNameFactory, useClassName } from "@contember/react-utils";
import { memo, forwardRef, useCallback } from "react";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { EditorToolbarButton } from "./EditorToolbarButton.js";
import { toStateClass } from "../../utils/toStateClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toViewClass } from "../../utils/toViewClass.js";
function ButtonOrDropdown(props) {
  const className = useClassName("editorToolbar-button");
  const renderToggle = useCallback(
    ({ ref, onClick }) => {
      return /* @__PURE__ */ jsx(
        EditorToolbarButton,
        {
          layout: props.layout,
          label: props.label,
          showLabel: props.showLabel,
          contemberIcon: props.contemberIcon,
          blueprintIcon: props.blueprintIcon,
          customIcon: props.customIcon,
          onClick,
          ref
        }
      );
    },
    [props.blueprintIcon, props.contemberIcon, props.customIcon, props.label, props.layout, props.showLabel]
  );
  if (props.groups) {
    return /* @__PURE__ */ jsx(Dropdown, { renderToggle, alignment: "center", styledContent: false, children: /* @__PURE__ */ jsx(
      EditorToolbar,
      {
        isActive: true,
        groups: props.groups,
        scope: props.popup.scope,
        layout: props.popup.layout,
        showLabels: props.popup.showLabels
      }
    ) });
  }
  return /* @__PURE__ */ jsx("div", { className, children: /* @__PURE__ */ jsx(EditorToolbarButton, { ...props }) });
}
const EditorToolbar = memo(forwardRef(({
  groups,
  isActive,
  layout,
  restGroups,
  scope,
  showLabels
}, ref) => {
  layout = layout ?? "bar";
  const buttonLayout = layout === "list" ? "list" : "grid";
  const componentClassName = useClassNameFactory("editorToolbar");
  if (restGroups) {
    switch (layout) {
      case "grid":
      case "list":
        groups = [...groups, ...restGroups];
        restGroups = void 0;
    }
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: componentClassName(null, [
        toStateClass("active", isActive),
        toEnumViewClass(scope),
        toViewClass(`layout-${layout}`, true)
      ]),
      ref,
      children: /* @__PURE__ */ jsxs("div", { className: componentClassName("groups"), children: [
        groups.map((g, i) => /* @__PURE__ */ jsx("div", { className: componentClassName("group"), children: g.buttons.map((b, i2) => /* @__PURE__ */ jsx(
          ButtonOrDropdown,
          {
            layout: buttonLayout,
            showLabel: showLabels,
            popup: {
              layout: "list",
              showLabels: true,
              scope
            },
            ...b
          },
          i2
        )) }, i)),
        restGroups && !!restGroups.length && /* @__PURE__ */ jsx("div", { className: componentClassName("group", "view-rest"), children: /* @__PURE__ */ jsx(
          ButtonOrDropdown,
          {
            label: "More…",
            contemberIcon: "ellipsis",
            groups: restGroups,
            showLabel: showLabels,
            popup: {
              layout: "grid",
              showLabels: true,
              scope
            }
          }
        ) })
      ] })
    }
  );
}));
EditorToolbar.displayName = "EditorToolbar";
export {
  EditorToolbar
};
//# sourceMappingURL=EditorToolbar.js.map
